import noop from 'utils/noop';
import { createContext, Dispatch, SetStateAction, useContext } from 'react';
import { CampaignStep } from '../types';

export type PromptState = {
  openModal: boolean;
  campaignStep?: CampaignStep;
  consumerCallback?: () => void;
};

export interface UnsavedChangesPromptContextState {
  promptState: PromptState;
  transitionToCampaignStep: (campaignStep: CampaignStep, transitionFn: () => void) => void;
  transitionTo: (transitionFn: () => void) => void;
  setPromptState: Dispatch<SetStateAction<PromptState>>;
}

export const DEFAULT_UNSAVED_CHANGES_PROMPT_CONTEXT_STATE: UnsavedChangesPromptContextState = {
  promptState: { openModal: false },
  transitionTo: noop,
  transitionToCampaignStep: noop,
  setPromptState: noop,
};

export const UnsavedChangesPromptContext = createContext<UnsavedChangesPromptContextState>(
  DEFAULT_UNSAVED_CHANGES_PROMPT_CONTEXT_STATE,
);
export const useUnsavedPromptContext = () => useContext(UnsavedChangesPromptContext);
